import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/admin/keys/keys.component.scss.shim.ngstyle.ts